function LabelsCharts(): JSX.Element {
  return <div>ChartsLabels</div>;
}

export default LabelsCharts;
